<template>
  <b-tag
    :type="type"
    :size="size"
    :rounded="rounded"
    :icon="icon"
    :icon-pack="iconPack"
    :icon-type="iconType"
    @close="onClose"
    @click="onClick"
  >
    <slot />
  </b-tag>
</template>
<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TagView',
  emits: ['close', 'click'],
  props: {
    type: {
      type: String
    },
    size: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    iconPack: {
      type: String,
      default: 'cls'
    },
    iconType: {
      type: String
    }
  },
  methods: {
    onClose(...args) {
      this.$emit('close', ...args);
    },
    onClick(...args) {
      this.$emit('click', ...args);
    }
  }
};
</script>
